import { Component, Input, OnInit } from "@angular/core";
import * as moment from "moment";

@Component({
  selector: "app-card-imc-component",
  templateUrl: "./card-imc-component.component.html",
  styleUrls: ["./card-imc-component.component.scss"],
})
export class CardImcComponentComponent implements OnInit {
  @Input("data") imc;
  @Input("ultimo") ultimo;
  statusImc: string = "-";
  colorStatusImc: string = "none";

  constructor() { }

  ngOnInit() {
    this.carregarLegendaImc();
  }

  abrirItem() {
    this.imc.selecionado = !this.imc.selecionado;
  }

  dateLabel(date: string) {
    return `${moment(date, "YYYY-MM-DD").format("L")}`;
  }

  carregarLegendaImc() {
    if (!this.imc) {
      return " - ";
    }
    if (this.imc.imc <= 25) {
      this.statusImc = "Adequado";
      this.colorStatusImc = "#2CA079";
    } else if (this.imc.imc < 30) {
      this.statusImc = "Acima do peso";
      this.colorStatusImc = "#F0B418";
    } else {
      this.statusImc = "Obeso";
      this.colorStatusImc = "#991818";
    }
  }
}
